module.exports = {
	"global": {
		"true": "Ja",
		"false": "Nee",
		"edit": "WIJZIG",
		"intentionally-left-blank": "U kunt dit account gebruiken om in te loggen in de app"
	},
	"menu": {
		"home": "Home",
		"change-profile": "Profiel",
		"change-password": "Wachtwoord wijzigen",
		"logout": "Uitloggen",
		"default": "Voorkeur",
		"set_as_default": "Instellen als voorkeur"
	},
	"loginpage": {
		"login-title": "Zehnder portal login",
		"username-placeholder": "Gebruikersnaam",
		"password-placeholder": "Wachtwoord",
		"forgot-password": "Wachtwoord vergeten?",
		"login-button": "INLOGGEN"
	},
	"backendselectorpage": {
		"title": "Kies een product",
		"rememberchoice": "Instellen als voorkeur"
	},
	"homepage": {
		"nav": {
			"home": "Home",
			"mypresets": "My Presets",
			"logs": "Logfiles"
		},
		"filter-placeholder": "Zoek op naam",
		"add-new-button": "NIEUWE TOEVOEGEN",
		"title-edit-variant": "VARIANT AANPASSEN",
		"tabs": {
			"installer-companies-tab": "INSTALLER COMPANIES",
			"add-installer-company-tab": "INSTALLER COMPANY TOEVOEGEN",
			"installers-tab": "INSTALLERS",
			"add-installer-tab": "INSTALLER TOEVOEGEN",
			"commercial-offers-tab": "COMMERCIAL OFFERS",
			"filter-shops-tab": "FILTERWINKELS",
			"products-tab": "PRODUCTBEHEER",
			"add-product-tab": "PRODUCT TOEVOEGEN",
			"add-variant-tab": "VARIANT TOEVOEGEN",
			"softwareVersions-tab": "FIRMWAREBEHEER",
			"add-softwareVersion-tab": "FIRMWARE TOEVOEGEN",
			"installer-tab": "INSTALLATEUR",
			"documents-tab": "DOCUMENTEN"
		},
		"table-headers": {
			"username": "GEBRUIKERSNAAM",
			"email": "EMAIL",
			"country2": "LAND",
			"companyName": "Bedrijfsnaam",
			"address": "ADRES",
			"phonenumber": "TELEFOONNUMMER",
			"something": "SOMETHING",
			"productID": "PRODUCT_ID",
			"version": "VERSIE",
			"releaseNotes": "RELEASE NOTES",
			"name": "NAAM",
			"edit": " ",
			"edit-header": "",
			"beta2": "BETA",
			"productName": "PRODUCT"
		},
		"installer-editor": {
			"add-installer": "Installer toevoegen",
			"edit-installer": "Installer wijzigen",
			"save-button": "Opslaan",
			"cancel-button": "Annuleren",
			"username-label": "Gebruikersnaam",
			"email-label": "Emailadres",
			"phone-label": "Telefoonnummer",
			"delete-label": "Verwijderen",
			"delete-title": "Verwijder een installer!",
			"change-password-title": "Wachtwoord wijzigen",
			"new-password-label": "Nieuw wachtwoord",
			"new-password-placeholder": "Nieuw wachtwoord",
			"confirm-password-label": "Herhaal wachtwoord",
			"confirm-password-placeholder": "Herhaal password"
		},
		"installer-company-editor": {
			"add-installer-company": "Installer company toevoegen",
			"edit-installer-company": "installer company wijzigen",
			"save-button": "Opslaan",
			"cancel-button": "Annuleren",
			"username-label": "Gebruikersnaam",
			"email-label": "Emailadres",
			"companyName-label": "Bedrijfsnaam",
			"address-label": "Adres",
			"country-label": "Land",
			"delete-label": "Verwijderen",
			"delete-title": "Verwijder een installer company!",
			"change-password-title": "Wachtwoord wijzigen",
			"beta-label": "Beta",
			"new-password-label": "Nieuw wachtwoord",
			"new-password-placeholder": "Nieuw wachtwoord",
			"confirm-password-label": "Herhaal wachtwoord",
			"confirm-password-placeholder": "Herhaal wachtwoord",
			"you-are-about-to-delete": "Verwijderen: ",
			"sure": "Weet u het zeker?",
			"empty-ic-name": "Vult u a.u.b. de naam van de installer company in",
			"invalid-email": "Ongeldig e-mailadres",
			"pick": "Kiezen...",
			"email-confirm-label": "E-mailadres bevestigen",
			"email-confirm-incorrect": "E-mailadressen zijn niet gelijk"
		},
		"commercial-offers": {
			"title": "Commercial Offers",
			"save-button": "Wijzigingen opslaan",
			"activation-date-placeholder": "Ingangsdatum",
			"end-date-placeholder": "Einddatum"
		},
		"filter-shops": {
			"title": "Filterwinkels",
			"save-button": "Wijzigingen opslaan"
		},
		"product-editor": {
			"add-product": "Product toevoegen",
			"edit-product": "Product wijzigen",
			"save-button": "Opslaan",
			"cancel-button": "Annuleren",
			"delete-label": "Verwijderen",
			"productID-label": "Product ID",
			"name-label": "Naam product",
			"articlePrefix-label": "Artikel prefix",
			"table-headers": {
				"variantID": "VARIANT_ID",
				"name": "NAAM",
				"edit": "WIJZIG"
			},
			"filter-placeholder": "Zoek op naam",
			"add-new-button": "VARIANT TOEVOEGEN",
			"add-variant": "Variant toevoegen",
			"edit-variant": "Variant toevoegen",
			"delete-title": "Verwijderen van een product!"
		},
		"softwareVersion-editor": {
			"add-softwareVersion": "Firmware version toevoegen",
			"edit-softwareVersion": "Firmware version wijzigen",
			"filter-placeholder": "Zoeken",
			"delete-label": "Verwijder firmware version",
			"version-label": "Versie",
			"releaseNotes-label": "Release notes",
			"product-label": "product",
			"save-button": "Opslaan",
			"cancel-button": "Annuleren",
			"delete-title": "Verwijderen van een firmware version!",
			"name-label": "Naam",
			"md5-label": "Md5",
			"choose-binary": "Kies een binary",
			"binary-label": "Binary",
			"beta-label": "Beta",
			"country-label": "Land",
			"table-headers": {
				"blockID": "BlockID",
				"name": "naam",
				"url": "url",
				"size": "groote",
				"md5": "md5",
				"articleIDs": "artikelen",
				"edit": "wijzig",
				"delete": "verwijderen"
			}
		},
		"documents-panel": {
			"title": "Documenten",
			"add-new-button": "Nieuwe toevoegen",
			"documents-list": {
				"delete-label": "Verwijderen",
				"delete-title": "Verwijderen van een document",
				"save-button": "Save",
				"cancel-button": "Cancel"
			},
			"download": "Download"
		},
		"document-editor": {
			"add-document": "Document toevoegen",
			"save-button": "Opslaan",
			"cancel-button": "Annuleren",
			"name-label": "Naam",
			"description-label": "Omschrijving",
			"type-label": "Type",
			"url-label": "URL",
			"file-label": "Bestand",
			"choose-file": "Kies bestand",
			"model-label": "Model",
			"country-label": "Land",
			"tabs": {
				"url-tab": "URL",
				"upload-tab": "BESTAND"
			},
			"no-name-entered": "Voer a.u.b. de naam van het document in",
			"no-description-entered": "Voer a.u.b. de beschrijving van het document in"
		}
	},
	"passwordpage": {
		"nav": {
			"home": "Home",
			"mypresets": "My presets",
			"logs": "Logfiles"
		},
		"title": "Wachtwoord wijzigen",
		"new-password-placeholder": "Nieuw wachtwoord",
		"confirm-password-placeholder": "Bevestig wachtwoord"
	},
	"forgotpasswordpage": {
		"title": "Aanvraag wachtwoordwijziging",
		"email-label": "E-mailadres",
		"send-email-button": "Verstuur email",
		"password-requested-message": "Wachtwoord e-mail verstuurd naar",
		"save-button": "Wijzig",
		"cancel-button": "Annuleren"
	},
	"changepasswordpage": {
		"title": "Wachtwoord wijzigen",
		"current-password-label": "Huidig wachtwoord",
		"current-password-placeholder": "Huidig wachtwoord",
		"new-password-label": "Nieuw wachtwoord",
		"new-password-placeholder": "Nieuw wachtwoord",
		"confirm-password-label": "Herhaal wachtwoord",
		"confirm-password-placeholder": "Herhaal password",
		"change-password-label": "Wijzig wachtwoord",
		"save-button": "Wijzig wachtwoord",
		"cancel-button": "Annuleren",
		"change-password-description": "Het nieuwe wachtwoord moet minimaal 8 tekens zijn, en moet bestaan uit ten minste een kleine letter, een hoofdletter, een cijfer en een speciaal teken.",
		"change-password-current": "Voer uw huidige wachtwoord in.",
		"change-password-confirm": "Bevestig uw nieuwe wachtwoord."
	},
	"profilepage": {
		"title": "Profiel",
		"companyName-label": "Bedrijfsnaam",
		"email-label": "Email",
		"address-label": "Adres",
		"language-label": "Taal",
		"save-button": "Opslaan",
		"cancel-button": "Annuleren"
	},
	"country": {
		"BELGIUM": "België",
		"NETHERLANDS": "Nederland",
		"GERMANY": "Duitsland",
		"UNITED_KINGDOM": "Verenigd Koninkrijk",
		"FRANCE": "Frankrijk",
		"AUSTRIA": "Oostenrijk",
		"POLAND": "Polen",
		"SWITZERLAND": "Switzerland",
		"ITALY": "Italë",
		"SPAIN": "Spanje",
		"NORTH_AMERICA": "Noord Amerika",
		"ALL_COUNTRIES": "Alle landen",
		"OTHER_COUNTRIES": "Overige landen"
	},
	"table": {
		"no-data-message": "Geen gegevens beschikbaar"
	},
	"error": {
		"login": {
			"invalid": "Ongeldige gebruikersnaam en/of wachtwoord.",
			"error": "Error tijdens het verbinden met de server.",
			"no_products": "Deze account heeft geen toegang tot een Zehnder-product."
		},
		"password": {
			"change-failed": "Het is niet gelukt uw wachtwoord te veranderen",
			"update-failed": "U bent niet ingelogd of gebruikt niet dezelfde browser als de aanvraag om uw wachtwoord te veranderen",
			"user-not-found": "Gebruiker met deze email kan niet gevonden worden",
			"insecure": "Wachtwoord moet minimaal 8 karakters lang zijn en minimaal 1 letter, 1 cijfer, 1 hoofdletter en een special teken bevatten",
			"too-short": "Wachtwoord moet minimaal 8 karakters lang zijn",
			"mismatch": "Huidig wachtwoord is incorrect",
			"dontmatch": "De wachtwoorden zijn niet gelijk",
			"password-changed": "Wachtwoord aangepast",
			"password-not-changed": "Het nieuwe wachtwoord is hetzelfde als het oude wachtwoord"
		},
		"manager": {
			"no-access": "U heeft geen toegang tot de manager",
			"load-fail": "Laden van manager niet goed gegaan"
		},
		"installer": {
			"no-access": "U heeft geen toegang tot de installers",
			"load-fail": "Laden van installers niet goed gegaan",
			"duplicate": "Installer met deze e-mail of gebruikersnaam bestaat al",
			"wrong-company": "Installer bestaat al, maar is geassocieerd met een ander bedrijf",
			"add-failed": "Toevoegen installer niet goed gegaan",
			"update-failed": "Wijzigen installer niet goed gegaan",
			"removed-failed": "Verwijderen installer niet goed gegaan"
		},
		"installer-company": {
			"no-access": "U heeft geen toegang tot de installer companies",
			"load-fail": "Laden van installer companies mislukt",
			"duplicate": "Installer company met dit e-mailadres of username bestaat al",
			"add-failed": "Installer company toevoegen mislukt.",
			"conflict": "De username en e-mailadres moeten uniek zijn.",
			"update-failed": "Updating installer company niet goed gegaan",
			"removed-failed": "Verwijderen installer company niet goed gegaan",
			"add-success": "Installer company aangemaakt. Er is ter verificatie een e-mail verstuurd naar het opgegeven e-mailadres.",
			"password-change": {
				"no-access": "U kan het wachtwoord van de installer company niet wijzigen",
				"failed": "Password change niet goed gegaan",
				"success": "Password has been changed"
			}
		},
		"softwareversion": {
			"no-access": "U heeft geen toegang tot de softwareversions",
			"load-fail": "Laden van softwareversions niet goed gegaan",
			"duplicate": "Softwareversions with this version already exists",
			"add-failed": "Adding Softwareversion niet goed gegaan",
			"update-failed": "Updating Softwareversion niet goed gegaan",
			"removed-failed": "Verwijderen Softwareversion niet goed gegaan"
		},
		"product": {
			"no-access": "U heeft geen toegang tot de products",
			"load-fail": "Laden van products niet goed gegaan",
			"add-failed": "Adding product niet goed gegaan",
			"update-failed": "Updating product niet goed gegaan",
			"removed-failed": "Verwijderen product niet goed gegaan"
		},
		"commercial-offer": {
			"no-access": "U heeft geen toegang tot de commercial offers",
			"load-failed": "Laden van commercial offers niet goed gegaan",
			"add-failed": "Toevoegen van commercial offer niet goed gegaan"
		},
		"filtershop": {
			"no-access": "U heeft geen toegang tot de filtershops",
			"load-failed": "Laden van filtershops niet goed gegaan",
			"add-failed": "Toevoegen van filtershop niet goed gegaan"
		},
		"documents": {
			"no-access": "U heeft geen toegang tot de documenten",
			"load-failed": "Laden van de documenten niet goed gegaan",
			"add-failed": "Toevoegen van document niet goed gegaan",
			"change-position-fail": "Veranderen van de volgorde is niet gelukt",
			"invalid-url": "Ongeldige URL"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// /locales/nl.json
// module id = 1309
// module chunks = 0